import { useState, useEffect } from 'react';
import api from '../utils/axios';
import MarksProjectChart from './charts/MarksProjectChart';
import { Box, Center, Spinner } from '@chakra-ui/react';

const MarksByProjects = () => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				const response = await api.get('/marks-info/marks-by-projects');
				setData(response.data);
				setLoading(false);
			} catch (err) {
				setError('Error fetching data');
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	if (loading) return <Center><Spinner /></Center>;
	if (error) return <div>{error}</div>;

	// Подсчет общего количества марок
	const totalMarks = data.reduce((acc, project) => acc + parseFloat(project.total_marks), 0);

	// Создание массива с процентами и сортировка
	const sortedData = data
		.map((project) => {
			const projectMarks = parseFloat(project.total_marks).toFixed(2);
			const percentage = totalMarks > 0 ? ((projectMarks / totalMarks) * 100).toFixed(2) : 0;

			return { ...project, percentage, projectMarks };
		})
		.sort((a, b) => b.percentage - a.percentage); // Сортировка по процентам

	return (
		<Box
			display="flex"
			flexDirection="column"
			backgroundColor="#FEF0DD"
			borderRadius="1.6rem"
			padding={4}
			width="full"
			height="full"
			alignItems="center"
			justifyContent={"center"}
			overflow="auto"
			position="relative"
		>
			<MarksProjectChart data={sortedData} /> {/* Вставка графика */}
		</Box>
	);
};

export default MarksByProjects;
